import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { tokens } from '../../../theme';

export default function ConfirmDelete({ deleteItem, deleteOpen, title = 'Delete item?', body = "This can't be undone." }) {
  return (
    <Dialog
      open={deleteOpen}
      onClose={() => deleteItem(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '14px',
          border: `1px solid ${tokens.border}`,
          boxShadow: '0 16px 40px rgba(44, 36, 27, 0.14)',
        },
      }}
    >
      <DialogTitle sx={{ fontFamily: "'Fraunces', 'Figtree', serif", fontWeight: 650, pb: 0.5 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 1.5 }}>
        <Typography variant="body2" sx={{ color: tokens.inkMuted, lineHeight: 1.5 }}>
          {body}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={() => deleteItem(false)}
          sx={{
            borderColor: tokens.border,
            color: tokens.inkMuted,
            minWidth: 96,
            '&:hover': { borderColor: tokens.brown, backgroundColor: tokens.bg },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => deleteItem(true)}
          sx={{
            minWidth: 96,
            backgroundColor: tokens.danger,
            '&:hover': { backgroundColor: '#8F4E42' },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
